import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import MarkDownView from '@/components/MarkDownView';
import { Button } from '@/components/ui/button';
import { useCourseData } from '@/pages/Course';
import { useGetKeynotes } from '@/features/course/hooks/useCourses';
import { Link } from 'react-router-dom';
import { ScrollArea } from '@/components/ui/scroll-area';

function KeyNotes() {
  const { course } = useCourseData();
  const getKeynotesAction = useGetKeynotes();
  const [loading, setLoading] = useState(false);
  return (
    <ScrollArea className="h-full">
      {course?.keyNotes?.length > 0 ? (
        <div className="flex flex-wrap gap-4 p-2">
          {course.keyNotes.map((notes, index) => (
            <div
              key={index}
              className="p-2 px-4 border-2 border-dashed shadow-md rounded-lg hover:shadow-lg transition-all">
              <Accordion type="single" collapsible>
                <AccordionItem value={notes?._id}>
                  <AccordionTrigger className="text-left text-sm font-semibold">{notes?.title}</AccordionTrigger>
                  <AccordionContent className="mt-2">
                    <MarkDownView>{notes?.content}</MarkDownView>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center rounded-lg border border-dashed m-2 shadow-sm p-2 sm:p-20">
          <div className="flex flex-col items-center gap-1 text-center h-full">
            <h3 className="text-2xl font-bold tracking-tight">
              Glossary / Revision notes
              <div className="h-1 mx-auto bg-gray-200 w-28 opacity-75 my-4 rounded"></div>
            </h3>
            <div className="flex flex-col items-center justify-center">
              <span className="text-sm text-muted-foreground text-left">
                Generate a comprehensive glossary to enhance your learning experience. It includes:
                <ul className="list-disc list-inside mt-2">
                  <li>Important definitions and formulas</li>
                  <li>Essential concepts</li>
                  <li>Key topics to remember</li>
                  <li>Important questions</li>
                  <li>Critical dates and events</li>
                  <li>Notable figures and their contributions</li>
                </ul>
              </span>
            </div>
            <Button
              onClick={async () => {
                setLoading(true);
                try {
                  await getKeynotesAction.mutateAsync({
                    courseId: course._id,
                    title: course.title,
                    language: course.language,
                  });
                } catch (error) {
                  console.error('Error generating keynotes:', error);
                } finally {
                  setLoading(false);
                }
              }}
              disabled={loading}
              className="my-2">
              {loading ? 'Generating...' : 'Generate'}
            </Button>
          </div>
        </div>
      )}
    </ScrollArea>
  );
}

export default KeyNotes;
